"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConfig = useConfig;
exports.useEnv = useEnv;
exports.useFeatureFlags = useFeatureFlags;
exports.useFeatureFlag = useFeatureFlag;
exports.useAssetTypesConfiguration = useAssetTypesConfiguration;
const react_1 = __importDefault(require("react"));
const contexts_1 = require("../contexts");
/**
 * Will return the configuration for Exchange, mostly defined in [this file](https://github.com/mulesoft/exchange-ui/blob/master/config/default.js) by using the [config](https://www.npmjs.com/package/config) package, typically for internal usage.
 *
 * @example
 *
 * ```ts
 * import { useConfig } from '@mulesoft/exchange-react-hooks';
 *
 * const MyComponent = ({ ...props }) => {
 *   const config = useConfig();
 *
 *   ...
 * };
 * ```
 *
 * @returns The config
 */
function useConfig() {
    return react_1.default.useContext(contexts_1.ConfigContext);
}
/**
 * Will return the actual environment.
 *
 * @example
 *
 * ```ts
 * import { useEnv } from '@mulesoft/exchange-react-hooks';
 *
 * const MyComponent = ({ ...props }) => {
 *   const env = useEnv();
 *
 *   ...
 * };
 * ```
 *
 * @returns The config
 */
function useEnv() {
    const config = useConfig();
    return config.env;
}
/**
 * Will return the value for an specific feature flag.
 *
 * @example
 *
 * ```ts
 * import { useFeatureFlag } from '@mulesoft/exchange-react-hooks';
 *
 * const MyComponent = ({ ...props }) => {
 *   const isFeatureFlagEnabled = useFeatureFlag('my-feature-flag');
 *
 *   ...
 * };
 * ```
 * @returns An object with all the feature flags
 */
function useFeatureFlags() {
    const config = react_1.default.useContext(contexts_1.ConfigContext);
    return config === null || config === void 0 ? void 0 : config.featureFlags;
}
/**
 * Will return all the feature flags as a key-value map.
 *
 * @example
 *
 * ```ts
 * import { useFeatureFlags } from '@mulesoft/exchange-react-hooks';
 *
 * const MyComponent = ({ ...props }) => {
 *   const featureFlags = useFeatureFlags();
 *   const isMyFlagEnabled = featureFlags['my-feature-flag'];
 *
 *   ...
 * };
 * ```
 *
 * @param key The key that represents the feature flag
 * @returns The value for the feature flag
 */
function useFeatureFlag(key) {
    var _a, _b;
    const config = react_1.default.useContext(contexts_1.ConfigContext);
    return (_b = (_a = config === null || config === void 0 ? void 0 : config.featureFlags) === null || _a === void 0 ? void 0 : _a[key]) !== null && _b !== void 0 ? _b : false;
}
function useAssetTypesConfiguration() {
    const assetTypesConfiguration = react_1.default.useContext(contexts_1.AssetTypesConfigurationContext);
    return assetTypesConfiguration;
}
